// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ArrowKeysNavigationController from "./arrow_keys_navigation_controller"
application.register("arrow-keys-navigation", ArrowKeysNavigationController)

import AutofocusController from "./autofocus_controller"
application.register("autofocus", AutofocusController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import Form__CheckboxEnablesController from "./form/checkbox_enables_controller"
application.register("form--checkbox-enables", Form__CheckboxEnablesController)

import Form__Html5ValidationsController from "./form/html5_validations_controller"
application.register("form--html5-validations", Form__Html5ValidationsController)

import Form__LabelAnimationsController from "./form/label_animations_controller"
application.register("form--label-animations", Form__LabelAnimationsController)

import Form__PasswordMatchController from "./form/password_match_controller"
application.register("form--password-match", Form__PasswordMatchController)

import Form__PasswordStrengthController from "./form/password_strength_controller"
application.register("form--password-strength", Form__PasswordStrengthController)

import Form__PasswordUnmaskController from "./form/password_unmask_controller"
application.register("form--password-unmask", Form__PasswordUnmaskController)

import Form__SubmitAfterDelayController from "./form/submit_after_delay_controller"
application.register("form--submit-after-delay", Form__SubmitAfterDelayController)

import Form__SubmitController from "./form/submit_controller"
application.register("form--submit", Form__SubmitController)

import HotwireAnimationsController from "./hotwire_animations_controller"
application.register("hotwire-animations", HotwireAnimationsController)

import Modal__BaseController from "./modal/base_controller"
application.register("modal--base", Modal__BaseController)

import Modal__OpenAndSubmitOnKeyPressController from "./modal/open_and_submit_on_key_press_controller"
application.register("modal--open-and-submit-on-key-press", Modal__OpenAndSubmitOnKeyPressController)

import NestedLinkInButtonController from "./nested_link_in_button_controller"
application.register("nested-link-in-button", NestedLinkInButtonController)

import PortfolioAnalyzer__AssetAllocationController from "./portfolio_analyzer/asset_allocation_controller"
application.register("portfolio-analyzer--asset-allocation", PortfolioAnalyzer__AssetAllocationController)

import PortfolioAnalyzer__ChartController from "./portfolio_analyzer/chart_controller"
application.register("portfolio-analyzer--chart", PortfolioAnalyzer__ChartController)

import PortfolioAnalyzer__RiskLevelAllocationsController from "./portfolio_analyzer/risk_level_allocations_controller"
application.register("portfolio-analyzer--risk-level-allocations", PortfolioAnalyzer__RiskLevelAllocationsController)

import RemovalsController from "./removals_controller"
application.register("removals", RemovalsController)

import ShowHideController from "./show_hide_controller"
application.register("show-hide", ShowHideController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import ZarazController from "./zaraz_controller"
application.register("zaraz", ZarazController)
